import React, { useEffect, useState, useRef } from "react";
import ResourcesTab from "./ResourcesTab";
import { useDispatch, useSelector } from "react-redux";
import * as rssFeedActions from "../../store/education/actions";
import * as rssWebinarsFeedActions from "../../store/webinars/actions";
import * as rssInfographicsFeedActions from "../../store/infographics/actions";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { ApplicationState } from "../../store";
import Dictionary from "./Dictionary";
import { useHistory } from "react-router-dom";
import i18nService from "../../util/Internationalization/i18n/i18n";
import RssFeedDetails from "./RssFeedDetails";
import { getFormattedDate } from "../../util/dateFormatting";
import LogoContainer from "../common/LogoContainer";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const Education = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const userType = "personal";
    const requestArticleData = () => dispatch(rssFeedActions.actionCreators.getRssFeedData(userType));
    const requestWebinarsData = () => dispatch(rssWebinarsFeedActions.actionCreators.getWebinarsRssFeedData(userType));
    const requestInfographicsData = () => dispatch(rssInfographicsFeedActions.actionCreators.getInfographicsRssFeedData(userType));

    const educationData = useSelector((state: ApplicationState) => (state.educationState ? state.educationState.educationData : []));
    const isLoading = useSelector((state: ApplicationState) => (state.educationState ? state.educationState.isLoading : false));
    const webinarsData = useSelector((state: ApplicationState) => (state.webinarsState ? state.webinarsState.webinarsData : []));
    const infographicsData = useSelector((state: ApplicationState) => (state.infographicsState ? state.infographicsState.infographicsData : []));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    const alphabetsForDictionary = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "0-9",
    ];
    const [activeIndex, setIndex] = useState(0);
    const [activeTab, setTab] = useState("A");
    const isBusinessUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userServiceDetails?.isBusinessUser);
    const [isDetails, setIsDetails] = useState(false);
    const [detailFeedId, setDetailFeedId] = useState("");

    const myRef = useRef<HTMLDivElement>(null);

    const changeIndex = (index: any, activeTab: string) => {
        setIndex(index);
        setTab(activeTab);
    };

    const isWhiteLabeled = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );

    const hasEducationAndBreach = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            ? state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            : false
    );

    const { t: tLang, i18n: i18nLang } = useTranslation();

    let isVisible = hasEducationAndBreach;

    useEffect(() => {
        window.scrollTo(0, 0);
        requestArticleData();
        requestWebinarsData();
        requestInfographicsData();
        if (!isVisible) {
            if (isBusinessUser == null) {
                history.push("/manage-account/protection-plan");
            } else if (isBusinessUser == true) {
                history.push("/dashboard");
            } else {
                history.push("/resources/calculators");
            }
        }
        if (history.location.search != null && history.location.search.length > 0) {
            educationData?.map((data:any)=>{
                if(data.feedUrl.split("resources/")[1].replace("/", "") ==history.location.search.replace("?", "")){
                    setDetailFeedId(data.feedUrl);
                    changeDetailsView();
                }
            })
        }
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [routeLoading, dispatch]);

    const changeFeedId = (feedUrl: string) => {
        const id = feedUrl.split("resources/")[1].replace("/", "");
        setDetailFeedId(feedUrl);
        changeDetailsView();
    };

    const changeDetailsView = () => {
        history.push("/resources/education");
        setIsDetails(!isDetails);
    };

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="resources-education-page" tabIndex={-1}>
                        Resources
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ResourcesTab selectedTab="4" />

            {!isDetails ? (
                <div className="row" id="content">
                    <div className="col-xs">
                        <div className="box offset-padding">
                            <div className="box-header">
                                <div className="box-title-container">
                                    <div className="box-title-icon" aria-hidden="true">
                                        <RenderIcons iconName="graduation-cap" />
                                    </div>
                                    <div className="box-title-text">
                                        <h2 className="box-title">Education</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="box-content">
                                {!isLoading ? (
                                    <>
                                        <div className="row">
                                            <div className="col-xs-12 col-gutter-vertical">
                                                <h3 className="content-sub-title">Articles</h3>

                                                <ul className="article-list">
                                                    {educationData != null &&
                                                        educationData.map((data: any, index: number) => (
                                                            <li key={index}>
                                                                <div className="article-container">
                                                                    <div className="article-image">
                                                                        <a
                                                                            rel="noreferrer"
                                                                            href="javascript:void(0);"
                                                                            aria-label={data.title}
                                                                            onClick={() => {
                                                                                window.addToDataLayer({ event: "Education Articles Image" });
                                                                                changeFeedId(data.feedUrl);
                                                                            }}
                                                                            tabIndex={-1}
                                                                        >
                                                                            <img
                                                                                style={{ left: "0%", top: "0%", transform: "none" }}
                                                                                src={data.imageUrl}
                                                                                alt="Article Image"
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                    <div className="article-content">
                                                                        <h4 className="article-title">
                                                                            <a
                                                                                rel="noreferrer"
                                                                                href="javascript:void(0);"
                                                                                title={data.title}
                                                                                onClick={() => {
                                                                                    window.addToDataLayer({ event: "Education Articles Link" });
                                                                                    changeFeedId(data.feedUrl);
                                                                                }}
                                                                            >
                                                                                {data.title.length > 57 ? data.title.substring(0, 57) + "..." : data.title}
                                                                            </a>
                                                                        </h4>
                                                                        <div className="article-intro">
                                                                            <p style={{ maxHeight: "100px", textOverflow: "ellipsis", overflow: "hidden" }}>
                                                                                {data && data.summary && data.summary.length > 197 ? data.summary.substring(0, 197) + "..." : data.summary}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="article-author-and-date">
                                                                        <div className="article-author-text">
                                                                            <div className="article-author-name">
                                                                                <span className="sr-only">Author: </span>
                                                                                {data.author}
                                                                            </div>
                                                                            <div className="article-published-date">
                                                                                <span className="sr-only">{tLang("dashboard.education.publishedOn")}: </span>
                                                                                {getFormattedDate(i18nService.get("Country"), data.publishDate)}
                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                                                                </div>
                                                            </li>
                                                        ))}
                                                </ul>
                                                
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-gutter-vertical">
                                                <h3 className="content-sub-title">Webinars</h3>
                                                {webinarsData != null &&
                                                    webinarsData.map((data: any, index: number) => (
                                                        <div key={"webinars-" + index} className="resource-container">
                                                            <a
                                                                href="javascript:void(0);"
                                                                className="resource-link"
                                                                onClick={() => {
                                                                    window.addToDataLayer({ event: "Webinars External Link" });
                                                                    changeFeedId(data.feedUrl);
                                                                }}
                                                            >
                                                                <span className="resource-icon">
                                                                    <em className="las la-tv"></em>
                                                                </span>
                                                                <span className="resource-text">
                                                                    <span className="resource-title">{data.title}</span>
                                                                    <span className="resource-description">{data.summary}</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    ))}

                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-gutter-vertical">
                                                <h3 className="content-sub-title">Infographics</h3>

                                                {infographicsData != null &&
                                                    infographicsData.map((data: any, index: number) => (
                                                        <div key={"infographics-" + index} className="resource-container">
                                                            <a
                                                                href="javascript:void(0);"
                                                                className="resource-link"
                                                                onClick={() => {
                                                                    window.addToDataLayer({ event: "Infographics External Link" });
                                                                    changeFeedId(data.feedUrl);
                                                                }}
                                                            >
                                                                <span className="resource-icon">
                                                                    <em className="las la-file-image"></em>
                                                                </span>
                                                                <span className="resource-text">
                                                                    <span className="resource-title">{data.title}</span>
                                                                    <span className="resource-description">{data.summary}</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    ))}

                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="box loading"></div>
                                )}
                            </div>
                        </div>

                        <div className="box offset-padding" ref={myRef}>
                            <div className="box-header">
                                <div className="box-title-container">
                                    <div className="box-title-icon" aria-hidden="true">
                                        <em className="las la-book"></em>
                                    </div>
                                    <div className="box-title-text">
                                        <h2 className="box-title">Cyber Crime and Security Terms</h2>
                                    </div>
                                </div>
                                <div className="box-description">
                                    <p>
                                        Familiarize yourself with these terms and definitions to boost your awareness of cyber threats and proactive cyber security
                                        tools.
                                    </p>
                                </div>
                                <div className="box-actions"></div>
                            </div>
                            <div className="box-content">
                                <ul className="m-dictionary-terms" id="letter-list">
                                    {alphabetsForDictionary.map((str, index) => (
                                        <li key={"dictionary-" + index}>
                                            <button
                                                type="button"
                                                className={
                                                    activeIndex === index
                                                        ? "btn-default btn-primary-outline btn-letter btn-is-active"
                                                        : "btn-default btn-primary-outline btn-letter"
                                                }
                                                id={"btn_terms_" + str}
                                                onClick={() => changeIndex(index, str)}
                                            >
                                                <span className="btn-text">
                                                    <span className="sr-only">View terms starting with</span> {str} <span className="sr-only">Selected</span>
                                                </span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                                <Dictionary selectedTab={activeTab} changeIndex={changeIndex} />
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <RssFeedDetails id={detailFeedId} backToArticles={changeDetailsView} />
            )}
        </React.Fragment>
    );
};

export default Education;
